import styled from 'styled-components'

import { breakpoint } from 'style/theme'

export default styled.div`
  padding: 70px 0 100px 0;
  max-width: 900px;
  margin: auto;

  .legal-container {
    margin-top: 40px;

    .text-p {
      margin-bottom: 15px;
    }

    .text-title {
      margin-bottom: 10px;
    }

    li {
      padding-left: 10px;
    }
  }

  @media (max-width: ${breakpoint.md}) {
    padding: 40px 0 60px 0;

    .legal-container {
      margin-top: 20px;
    }
  }
`
